import React from "react"
import { Link } from "gatsby"
import PersonalHomeIcon from "../../assets/img/kuda-house-light.inline.svg";
import TransferIcon from "../../assets/img/pay-icon-green.inline.svg";
import SaveIcon from "../../assets/img/save-icon-yellow.inline.svg"
import InvestmentIcon from "../../assets/img/bar-graph-fill.inline.svg";
import CardIcon from "../../assets/img/card-icon-green.inline.svg"
import BulbIcon from "../../assets/img/kuda-bulb-red.inline.svg"
import WifiIcon from "../../assets/img/kuda-wifi.inline.svg"
import AirtimeIcon from "../../assets/img/airtime-icon-green.inline.svg"
import BettingIcon from "../../assets/img/betting-icon.inline.svg"
import TransportIcon from "../../assets/img/k-Transport.inline.svg"
import GiftCardIcon from "../../assets/img/gift-card-light.inline.svg"
import CardlessIcon from "../../assets/img/kuda-web-yellow.inline.svg"
import TVIcon from "../../assets/img/k-tv.inline.svg"
import OverdraftIcon from "../../assets/img/kuda-overdraft-blue.inline.svg"
import SalaryLoanIcon from '../../assets/img/kuda-salary-loan-icon.inline.svg'

import BusinessHomeIcon from "../../assets/img/kuda-home.inline.svg";
import BusinessOfficeIcon from "../../assets/img/kuda-office.inline.svg";
import SendMoneyIcon from '../../assets/img/kuda-send.inline.svg';
import CashDepositIcon from '../../assets/img/kuda-cash-deposit.inline.svg';
import BorrowIcon from "../../assets/img/borrow-icon.inline.svg"
import SoftPOSIcon from "../../assets/img/kuda-softpos.inline.svg";
import POSMachineIcon from '../../assets/img/kuda-pos-machine.inline.svg';
import VirtualPOSIcon from '../../assets/img/kuda-virtual-pos.inline.svg';
import InvoiceIcon from "../../assets/img/kuda-invoice.inline.svg"
import BusinessLoanIcon from '../../assets/img/kuda-loan-icon.inline.svg'
import BusinessAPIIcon from '../../assets/img/kuda-business-api.inline.svg'
import PayrollBentoIcon from '../../assets/img/kuda-bento.inline.svg'
import KudaPayrollIcon from '../../assets/img/kuda-payroll.inline.svg'
import SubAccountIcon from '../../assets/img/kuda-sub-acount.inline.svg'
import SpendMoneyIcon from '../../assets/img/kuda-money-business.inline.svg'
import ExpenseCardIcon from '../../assets/img/expense-card-icon.inline.svg';

const NgGlobalHeaderOptions = (props) => {
    const { removeMenu, textColor, toggleMenu, renderDropdownIcon } = props
    return (
        <ul className="kuda-menu--wrap flex align-center">
            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p className={`no-link ${textColor}`} onMouseEnter={removeMenu}>
                    Personal
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu">
                    <div className="kuda-dropdown--menu drop-min--width py-0">
                        <div className="flex justify-between">

                            <ul className="drop-min--width py-4">
                                <li className="nav-list-item">
                                    <Link
                                        to="/en-ng/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <PersonalHomeIcon />
                                        </span>
                                        <span className="nav-link-text">Discover Personal</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/spend/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <TransferIcon />
                                        </span>
                                        <span className="nav-link-text">Transfer & Spend</span>

                                    </Link>
                                </li>
                                {/* <li>
                                    <Link
                                        disabled={true}
                                        to="/en-ng/spend/"
                                        className="menu-link disabled"
                                    >
                                        <span className="menu-link--icon">
                                            <BudgetIcon />
                                        </span>
                                        <span className="nav-link-text">Budget</span>
                                        <span className="coming-soon">Coming Soon</span>
                                    </Link>
                                </li> */}
                                <li>
                                    <Link to="/en-ng/save/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <SaveIcon />
                                        </span>
                                        <span className="nav-link-text">Save</span>

                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/investments/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <InvestmentIcon />
                                        </span>
                                        <span className="nav-link-text">Investments</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/cards/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <CardIcon />
                                        </span>
                                        <span className="nav-link-text">Kuda Card</span>
                                    </Link>
                                </li>
                            </ul>
                            <ul className="bg-offwhite drop-min--width py-4">
                                <div className="px-4 pt-3 pb-1 text-xs">PAYMENTS</div>
                                <li>
                                    <Link
                                        to="/bill-payments/electricity/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BulbIcon />
                                        </span>
                                        <span className="nav-link-text">Electricity</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/airtime/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <AirtimeIcon />
                                        </span>
                                        <span className="nav-link-text">Airtime</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/bill-payments/internet/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <WifiIcon />
                                        </span>
                                        <span className="nav-link-text">Internet</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/gift-cards/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <GiftCardIcon />
                                        </span>
                                        <span className="nav-link-text"> Gift Cards</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link to="/en-ng/cardless-payments/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <CardlessIcon />
                                        </span>
                                        <span className="nav-link-text">Cardless Payments</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link to="/en-ng/bill-payments/tv/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <TVIcon />
                                        </span>
                                        <span className="nav-link-text">TV</span>

                                    </Link>
                                </li>

                                <li>
                                    <Link to="/en-ng/bill-payments/betting/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <BettingIcon />
                                        </span>
                                        <span className="nav-link-text">Betting</span>

                                    </Link>
                                </li>

                                <li>
                                    <Link to="/en-ng/bill-payments/cowry/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <TransportIcon />
                                        </span>
                                        <span className="nav-link-text">Transport</span>

                                    </Link>
                                </li>
                                <div className="px-4 pt-3 pb-1 text-xs">CREDIT</div>
                                <li>
                                    <Link
                                        to="/en-ng/overdrafts/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <OverdraftIcon />
                                        </span>
                                        <span className="nav-link-text">Overdrafts</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/personal-loan/"
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BorrowIcon />
                                        </span>
                                        <span className="nav-link-text">Loans</span>
                                    </Link>
                                </li>
                                {/* <div className="px-4 pt-3 pb-1 text-xs">HOW KUDA HELPS YOU</div>
                                <li>
                                    <Link
                                        to="/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <TimelineIcon />
                                        </span>
                                        <span className="nav-link-text">Grow your Money</span>

                                    </Link>
                                </li> */}
                                {/* <li>
                                    <Link
                                        to="/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <WarningIcon />
                                        </span>
                                        <span className="nav-link-text">Avoiding failed Transaction</span>

                                    </Link>
                                </li>  */}
                            </ul>
                        </div>


                    </div>
                </div>
            </li>
            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p className={`no-link ${textColor}`} onMouseEnter={removeMenu}>
                    Business
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu">

                    <div className="kuda-dropdown--menu drop-min--width py-0">
                        <div className="flex justify-between">

                            <ul className="drop-min--width py-4">
                                <li>
                                    <Link
                                        to="/en-ng/business/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BusinessHomeIcon />
                                        </span>
                                        <span className="nav-link-text"> Discover Business</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/business/registration-cac-tin/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BusinessOfficeIcon />
                                        </span>
                                        <span className="nav-link-text">Business Registration</span>

                                    </Link>
                                </li>


                                <li>
                                    <Link
                                        to="/en-ng/business/payroll/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <KudaPayrollIcon />
                                        </span>
                                        <span className="nav-link-text">Kuda Payroll</span>
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/open-api/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BusinessAPIIcon />
                                        </span>
                                        <span className="nav-link-text">Business API</span>
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/payroll-software/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <PayrollBentoIcon />
                                        </span>
                                        <span className="nav-link-text">Payroll with Bento</span>
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/expense-accounts/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <SubAccountIcon />
                                        </span>
                                        <span className="nav-link-text">Expense Accounts</span>
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/expense-card/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <ExpenseCardIcon />
                                        </span>
                                        <span className="nav-link-text">Expense Cards</span>
                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/cashback-airtime-bills/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <SpendMoneyIcon />
                                        </span>
                                        <span className="nav-link-text">Cashback</span>

                                    </Link>
                                </li>

                            </ul>

                            <ul className="bg-offwhite drop-min--width py-4">
                                <div className="px-4 pt-3 pb-1 text-xs">PAYMENTS</div>
                                <li>
                                    <Link to="/en-ng/business/send-money/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <SendMoneyIcon />
                                        </span>
                                        <span className="nav-link-text">Send Money</span>

                                    </Link>
                                </li>

                                <li>
                                    <Link to="/en-ng/business/bill-payments/cable-tv/" onClick={toggleMenu} className="menu-link">
                                        <span className="menu-link--icon">
                                            <TVIcon />
                                        </span>
                                        <span className="nav-link-text">TV</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/business/bill-payments/airtime-internet-data/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <AirtimeIcon />
                                        </span>
                                        <span className="nav-link-text">Airtime & Internet Data</span>

                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/business/bill-payments/electricity-meter-units/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BulbIcon />
                                        </span>
                                        <span className="nav-link-text">Electricity</span>

                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/bill-payments/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <CashDepositIcon />
                                        </span>
                                        <span className="nav-link-text">Bill Payments</span>

                                    </Link>
                                </li>

                                <div className="px-4 pt-3 pb-1 text-xs">CREDIT</div>

                                <li>
                                    <Link
                                        to="/en-ng/business/loans/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <BusinessLoanIcon />
                                        </span>
                                        <span className="nav-link-text">Business Loan</span>

                                    </Link>
                                </li>
                                <div className="px-4 pt-3 pb-1 text-xs">COLLECTIONS</div>
                                <li>
                                    <Link
                                        to="/en-ng/business/softpos-payments/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <SoftPOSIcon />
                                        </span>
                                        <span className="nav-link-text">softPOS</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/business/invoicing/"

                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <InvoiceIcon />
                                        </span>
                                        <span className="nav-link-text">Invoicing for Business</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/en-ng/business/pos/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <POSMachineIcon />
                                        </span>
                                        <span className="nav-link-text">POS Machine</span>

                                    </Link>
                                </li>

                                <li>
                                    <Link
                                        to="/en-ng/business/virtual-pos/"
                                        onClick={toggleMenu}
                                        className="menu-link"
                                    >
                                        <span className="menu-link--icon">
                                            <VirtualPOSIcon />
                                        </span>
                                        <span className="nav-link-text">Virtual POS</span>

                                    </Link>
                                </li>

                            </ul>


                        </div>
                    </div>
                </div>
            </li>

            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p className={`no-link ${textColor}`} onMouseEnter={removeMenu}>
                    Company
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu">
                    <ul className="kuda-dropdown--menu">

                        <li>
                            <Link
                                to="/blog/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                <span className="nav-link-text">Blog</span>

                            </Link>

                            {/* <p className="menu-link" onClick={() => openURLInNewWindow('https://joinkuda.medium.com/')}>Blog</p> */}

                        </li>
                        <li>
                            <Link
                                to="/press/"
                                onClick={toggleMenu}
                                className="menu-link"
                            > <span className="nav-link-text">Press</span>

                            </Link>
                        </li>
                        <li>
                            <a
                                aria-label="Join Our Team"
                                href="/careers/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={toggleMenu}
                                className="menu-link"
                            ><span className="nav-link-text"> Join Our Team</span>

                            </a>
                        </li>
                        <li>
                            <Link
                                to="/about/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                <span className="nav-link-text">About Us</span>

                            </Link>
                        </li>
                        {/* {props.selectCountry ==="Nigeria" &&
                            <li>
                                <Link
                                    to="/en-ng/kudamfb/"
                                    onClick={toggleMenu}
                                    className="menu-link"
                                >
                                    <span className="nav-link-text">Kuda in Nigeria</span>

                                </Link>
                            </li>
                        } */}

                    </ul>
                </div>
            </li>

            <li className="kuda-nav--menu" data-toggle="dropdown">
                <p
                    className={`no-link ${textColor}`}
                    onMouseEnter={removeMenu}
                >
                    Help
                    <span className="dropDown">
                        {renderDropdownIcon()}
                    </span>
                </p>
                <div className="dropdown-menu global-overlay">
                    <ul className="kuda-dropdown--menu">
                        <li>
                            <a
                                aria-label="Get Help"
                                href="https://help.kuda.com/en/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={toggleMenu}
                                className="menu-link"
                            >

                                <span className="nav-link-text">Get Help</span>

                            </a>
                        </li>
                        <li>
                            <Link to="/scam-awareness/" onClick={toggleMenu} className="menu-link">

                                <span className="nav-link-text">Scam Awareness</span>

                            </Link>
                        </li>
                        <li>
                            <Link to="/en-ng/legal/faq/" onClick={toggleMenu} className="menu-link">

                                <span className="nav-link-text">FAQs</span>
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/security/"
                                onClick={toggleMenu}
                                className="menu-link"
                            >
                                <span className="nav-link-text">Security</span>

                            </Link>
                        </li>

                        <li>
                            <Link to="/contact/" onClick={toggleMenu} className="menu-link">

                                <span className="nav-link-text">Contact Us</span>

                            </Link>
                        </li>
                        <li>
                            <a
                                aria-label="Self Help"
                                href="https://selfhelp.kuda.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={toggleMenu}
                                className="menu-link"
                            >  <span className="nav-link-text">Self Help</span>


                            </a>
                        </li>
                    </ul>
                </div>
            </li>

        </ul>

    )
}
export default React.memo(NgGlobalHeaderOptions)